import { render, staticRenderFns } from "./calendarNotificationItem.vue?vue&type=template&id=7a310e4e&scoped=true"
import script from "./calendarNotificationItem.vue?vue&type=script&lang=js"
export * from "./calendarNotificationItem.vue?vue&type=script&lang=js"
import style0 from "./calendarNotificationItem.vue?vue&type=style&index=0&id=7a310e4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a310e4e",
  null
  
)

export default component.exports